import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { formModalSaved, isFormModalOpen } from '../../shared/formModal.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

// Turns the form into the JSON body the API expects.
function readForm(form) {
  const data = Object.fromEntries(new FormData(form).entries());

  // An unchecked checkbox is not submitted at all, so the absent key is the
  // "false" the server needs to see - FormData cannot express it.
  data.aktiv = form.querySelector('#aktiv')?.checked ?? true;

  // The empty option means "no leader". Sending '' would fail the isMongoId
  // check, so the key comes off entirely and the schema default applies.
  if (!data.leiter) delete data.leiter;

  return data;
}

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');
  const { filialeId } = form.dataset;
  const data = readForm(form);

  if (submitButton) submitButton.disabled = true;
  showLoading('Wird gespeichert …');

  try {
    if (filialeId) await http.patch(`/filialen/${filialeId}`, data);
    else await http.post('/filialen', data);

    const key = filialeId ? 'filiale-aktualisiert' : 'filiale-erstellt';

    // In the dialog the list is already on screen behind it, so closing and
    // refetching shows the result without a reload. On the standalone page
    // there is nothing to go back to, so it navigates as it always did and the
    // flash key carries the message across the load.
    if (isFormModalOpen()) {
      hideLoading();
      // Before formModalSaved, for the reason kundeForm.js spells out: onSaved may
      // navigate, and Notiflix painting into an unloading document throws.
      notifySuccess(filialeId ? 'Filiale wurde aktualisiert.' : 'Filiale wurde erstellt.');
      formModalSaved();
    } else {
      window.location.href = withFlash('/filialen', key);
    }
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initFilialeForm() {
  // Binds on this page load and again whenever the modal delivers this form,
  // since the element only exists from that moment on.
  bindFormModule('filiale-form', submit);
}
